import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas.sort((a, b) => (a.name || '').localeCompare(b.name || '')) },
    filtered: (state, datas) => { state.filtered = [...new Set(datas.map(item => item.id))] },
    filteredEventUnit: (state, datas) => {
      state.filtered = [...new Set(datas.map(item => item.classificationId))]
    }
  },
  actions: {
    init (state) { socket.get('SportSportClassification', 'Sport/Classification/init') },
    set (state, data) {
      state.state.filtered = []

      if (data.sportId) {
        if (data.seasonId > 0 || data.competitionsId.length > 0) {
          const parameters = {
            columns: {
              classificationId: 'SportSportEventunitclassification.classificationId'
            },
            joinr: [
              'SportSportRound.eventUnitId',
              'SportSportEventunitclassification.eventUnitId'
            ],
            join: [
              'SportSportRound.competitionSeasonId',
              'SportSportEventunitclassification.classificationId'
            ]
          }

          if (data.seasonId > 0) {
            parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
          }

          if (data.competitionsId.length === 1) {
            parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
          } else if (data.competitionsId.length > 1) {
            parameters['SportSportCompetitionseason.competitionId'] = {
              column: 'SportSportCompetitionseason.competitionId',
              operator: 'in',
              value: data.competitionsId
            }
          }

          if (data.eventId) {
            parameters['SportSportEventunit.eventId'] = data.eventId
          } else if (data.disciplineId) {
            parameters['SportSportEvent.disciplineId'] = data.disciplineId
            parameters.join.push('SportSportEventunit.eventId')
          } else if (data.sportId) {
            parameters['SportSportDiscipline.sportId'] = data.sportId
            parameters.join.push('SportSportEventunit.eventId')
            parameters.join.push('SportSportEvent.disciplineId')
          }

          socket.get('SportSportEventunit', 'Sport/Classification/filteredEventUnit', parameters)
        } else {
          const parameters = {}
          if (data.disciplineId) {
            parameters.disciplineId = data.disciplineId
          } else if (data.sportId) {
            parameters['SportSportDiscipline.sportId'] = data.sportId
            parameters.join = ['SportSportClassification.disciplineId']
          }

          socket.get('SportSportClassification', 'Sport/Classification/filtered', parameters)
        }
      }
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered
  }
}
